var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { staticClass: "pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pt-0",
              class: { "mt-md-n10": !_vm.noMarginTop },
              attrs: { cols: "12", sm: "12", md: _vm.showFilters ? 4 : 2 },
            },
            [
              _c("div", { staticClass: "d-flex align-start" }, [
                _c(
                  "div",
                  { staticClass: "flex-grow-1" },
                  [
                    _vm.currentUser.clientType === "Media" ||
                    _vm.currentUser.clientType === "Driblab"
                      ? _c("MediaModeForm", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showFilters,
                              expression: "showFilters",
                            },
                          ],
                          attrs: {
                            fields: _vm.mediaModeFields,
                            mediaMode: _vm.mediaMode,
                            mediaModeData: _vm.mediaModeData,
                            selectorMode: "",
                          },
                          on: {
                            mediaModeChange: function ($event) {
                              return _vm.onMediaModeChange($event)
                            },
                            mediaModeDataChange: function ($event) {
                              return _vm.onMediaModeDataChange($event)
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-card",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showFilters,
                            expression: "showFilters",
                          },
                        ],
                        staticClass: "pb-2",
                        attrs: { elevation: "0", outlined: "" },
                      },
                      [
                        _c(
                          "v-row",
                          { staticClass: "mx-0 pt-0" },
                          [
                            _c(
                              "v-col",
                              { staticClass: "py-3", attrs: { cols: "12" } },
                              [
                                _c(
                                  "v-card-title",
                                  {
                                    staticClass: "pa-0 header-font pt-2",
                                    staticStyle: { "font-size": "22px" },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("general.filters")))]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              { staticClass: "py-0", attrs: { cols: "12" } },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-0 pa-0 primary--text font-weight-bold body-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("general.displayType"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "pt-2 ma-0",
                                    attrs: {
                                      mandatory: "",
                                      row: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.displayModel,
                                      callback: function ($$v) {
                                        _vm.displayModel = $$v
                                      },
                                      expression: "displayModel",
                                    },
                                  },
                                  [
                                    _vm.mode === "pass-map"
                                      ? [
                                          _c("v-radio", {
                                            attrs: {
                                              value: "map",
                                              color: "secondary",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "game.passMap.pitchView"
                                                              )
                                                            ) + " "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "ms-1",
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "border_horizontal"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3217721350
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            staticClass: "mr-0",
                                            attrs: {
                                              value: "table",
                                              color: "secondary",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "charts.table"
                                                              )
                                                            ) + " "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "ms-1",
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "table_rows"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1269407284
                                            ),
                                          }),
                                        ]
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.mode === "connections"
                                      ? [
                                          _c("v-radio", {
                                            attrs: {
                                              value: "map",
                                              color: "secondary",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "game.passMap.pitchView"
                                                              )
                                                            ) + " "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "ms-1",
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "border_horizontal"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3217721350
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            attrs: {
                                              value: "matrix",
                                              color: "secondary",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "game.passMap.passingMatrix"
                                                              )
                                                            ) + " "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "ms-1",
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [_vm._v("grid_on")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              3484328876
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("v-radio", {
                                            staticClass: "mr-0",
                                            attrs: {
                                              value: "table",
                                              color: "secondary",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "label",
                                                  fn: function () {
                                                    return [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "body-1 primary--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "charts.table"
                                                              )
                                                            ) + " "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "ms-1",
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "table_rows"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              false,
                                              1269407284
                                            ),
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.displayModel === "map"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-1 mt-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "my-0 pa-0 primary--text font-weight-bold body-1 mb-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("general.orientation"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-radio-group",
                                      {
                                        staticClass: "mt-0",
                                        attrs: {
                                          row: "",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.passMapKey += 1
                                            _vm.passEventsKey += 1
                                          },
                                        },
                                        model: {
                                          value: _vm.orientationModel,
                                          callback: function ($$v) {
                                            _vm.orientationModel = $$v
                                          },
                                          expression: "orientationModel",
                                        },
                                      },
                                      [
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "horizontal",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "general.horizontal"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1570001633
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "vertical",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "general.vertical"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            47682317
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              {
                                staticClass: "py-1 my-2",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-0 pa-0 primary--text font-weight-bold body-1 mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("game.passMap.team")) + ":"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.gameData
                                  ? _c(
                                      "v-radio-group",
                                      {
                                        staticClass: "mt-0 pt-0",
                                        attrs: {
                                          column:
                                            _vm.$vuetify.breakpoint.xsOnly,
                                          row: !_vm.$vuetify.breakpoint.xsOnly,
                                          "hide-details": "",
                                          dense: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.filterPasses("team")
                                          },
                                        },
                                        model: {
                                          value: _vm.teamModel,
                                          callback: function ($$v) {
                                            _vm.teamModel = $$v
                                          },
                                          expression: "teamModel",
                                        },
                                      },
                                      [
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.gameData[0].teamName,
                                            value: true,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.gameData[0]
                                                              .teamName
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            3835590026
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.gameData[1].teamName,
                                            value: false,
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.gameData[1]
                                                              .teamName
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2759025995
                                          ),
                                        }),
                                      ],
                                      1
                                    )
                                  : _c("v-skeleton-loader", {
                                      staticClass: "mt-6 ml-lg-4",
                                      attrs: { type: "text" },
                                    }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.mode !== "pass-map" ||
                            _vm.displayModel !== "table"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "pb-2 pt-0 my-0",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c("v-range-slider", {
                                      staticClass: "align-center",
                                      attrs: {
                                        label: _vm.$t("game.passMap.minutes"),
                                        "thumb-label": "",
                                        min: _vm.rangeMinutes[0],
                                        max: _vm.rangeMinutes[1],
                                        step: "1",
                                        "hide-details": "",
                                        color: `secondary ${
                                          _vm.$vuetify.theme.dark
                                            ? "lighten-3"
                                            : ""
                                        }`,
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.filterPasses("minutes")
                                          _vm.passEventsKey += 1
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "label",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "primary--text font-weight-bold body-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.minutes"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-2 subheader-font monospace-font",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            `(${_vm.rangeMinutes[0]} - ${_vm.rangeMinutes[1]})`
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3343896217
                                      ),
                                      model: {
                                        value: _vm.minutes,
                                        callback: function ($$v) {
                                          _vm.minutes = $$v
                                        },
                                        expression: "minutes",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mode === "pass-map" &&
                            _vm.displayModel === "map"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-1 mt-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "my-0 pa-0 primary--text font-weight-bold body-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("game.passMap.passer"))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-autocomplete", {
                                      staticClass: "body-1 mb-2",
                                      attrs: {
                                        items: [
                                          {
                                            text: _vm.$t("game.passMap.all"),
                                            value: "",
                                          },
                                          ..._vm.teamPlayerNames.map((p) => ({
                                            text: p,
                                            value: p,
                                          })),
                                        ],
                                        "item-text": "text",
                                        "item-value": "value",
                                        dense: "",
                                        "hide-details": "",
                                        clearable: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.passEventsKey++
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "item",
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 primary--text",
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        451029087
                                      ),
                                      model: {
                                        value: _vm.selectedPlayer,
                                        callback: function ($$v) {
                                          _vm.selectedPlayer = $$v
                                        },
                                        expression: "selectedPlayer",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mode === "pass-map" &&
                            _vm.displayModel === "map" &&
                            _vm.hasReceiverData
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-1 mt-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "my-0 pa-0 primary--text font-weight-bold body-1",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("game.passMap.receiver") ||
                                              "Receiver"
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("v-autocomplete", {
                                      staticClass: "body-1 mb-2",
                                      attrs: {
                                        items: [
                                          {
                                            text: _vm.$t("game.passMap.all"),
                                            value: "",
                                          },
                                          ..._vm.teamPlayerNames.map((p) => ({
                                            text: p,
                                            value: p,
                                          })),
                                        ],
                                        "item-text": "text",
                                        "item-value": "value",
                                        dense: "",
                                        "hide-details": "",
                                        clearable: "",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.passEventsKey += 1
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "item",
                                            fn: function ({ item }) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "body-2 primary--text",
                                                  },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        451029087
                                      ),
                                      model: {
                                        value: _vm.selectedReceiver,
                                        callback: function ($$v) {
                                          _vm.selectedReceiver = $$v
                                        },
                                        expression: "selectedReceiver",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-col",
                              {
                                staticClass: "pb-1",
                                attrs: { cols: "12", sm: "12" },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "my-0 pa-0 primary--text font-weight-bold body-1 mt-2 mb-1",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("arrigo.visualization"))
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "d-flex mt-0 pa-0 ma-0" },
                                  [
                                    _c("v-checkbox", {
                                      staticClass: "mr-4 pa-0 ma-0",
                                      attrs: {
                                        color: "secondary",
                                        dense: "",
                                        "hide-details": "",
                                        "data-testid":
                                          "lbp-team-circles-checkbox",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.passEventsKey++
                                        },
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.circles"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.showCircles,
                                        callback: function ($$v) {
                                          _vm.showCircles = $$v
                                        },
                                        expression: "showCircles",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("v-checkbox", {
                                      staticClass: "mr-4 pa-0 ma-0",
                                      attrs: {
                                        color: "secondary",
                                        dense: "",
                                        "hide-details": "",
                                        "data-testid":
                                          "lbp-team-lines-checkbox",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.passEventsKey++
                                        },
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "label",
                                          fn: function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "body-1 primary--text",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "finishingMap.lines"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                      model: {
                                        value: _vm.showLines,
                                        callback: function ($$v) {
                                          _vm.showLines = $$v
                                        },
                                        expression: "showLines",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.mode === "pass-map" &&
                            _vm.displayModel === "map"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-1 mt-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        staticClass: "mt-0",
                                        attrs: {
                                          column: "",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.passEventsKey += 1
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mr-8 primary--text font-weight-bold body-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "game.passMap.passOutcome"
                                                          ) || "Pass Outcome"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          304156527
                                        ),
                                        model: {
                                          value: _vm.passOutcome,
                                          callback: function ($$v) {
                                            _vm.passOutcome = $$v
                                          },
                                          expression: "passOutcome",
                                        },
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "all",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.all"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2803333093
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "successful",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "eventChart.successful"
                                                            ) || "Successful"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            764447849
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "unsuccessful",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "eventChart.unsuccessful"
                                                            ) || "Unsuccessful"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            828395401
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mode === "pass-map" &&
                            _vm.displayModel === "map"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-1 mt-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        staticClass: "mt-0",
                                        attrs: {
                                          column: "",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.passEventsKey += 1
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mr-8 primary--text font-weight-bold body-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "game.passMap.passDirection"
                                                          ) || "Pass Direction"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3917185167
                                        ),
                                        model: {
                                          value: _vm.passDirection,
                                          callback: function ($$v) {
                                            _vm.passDirection = $$v
                                          },
                                          expression: "passDirection",
                                        },
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "all",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.all"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2803333093
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "forward",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.forwards"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2788529516
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "backward",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.backwards"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            973939100
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "sideways",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.sideways"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1678354819
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "longBall",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.longBall"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1506265293
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mode === "pass-map" &&
                            _vm.displayModel === "map"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-1 mt-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        staticClass: "mt-0",
                                        attrs: {
                                          column: "",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            _vm.passEventsKey += 1
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mr-8 primary--text font-weight-bold body-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "game.passMap.half"
                                                          ) || "Half"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          750696559
                                        ),
                                        model: {
                                          value: _vm.passHalf,
                                          callback: function ($$v) {
                                            _vm.passHalf = $$v
                                          },
                                          expression: "passHalf",
                                        },
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "all",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.all"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2803333093
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "offensive",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.offensive"
                                                            ) || "Offensive"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2276402596
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            value: "defensive",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.defensive"
                                                            ) || "Defensive"
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            93595172
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.mode === "connections"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "py-1 mt-2",
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "v-radio-group",
                                      {
                                        staticClass: "mt-0",
                                        attrs: {
                                          column: "",
                                          dense: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.filterPasses()
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mr-8 primary--text font-weight-bold body-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "game.passMap.select"
                                                          )
                                                        ) + ":"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3436322646
                                        ),
                                        model: {
                                          value: _vm.passesType,
                                          callback: function ($$v) {
                                            _vm.passesType = $$v
                                          },
                                          expression: "passesType",
                                        },
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t("game.passMap.all"),
                                            value: "all",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.all"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2803333093
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t(
                                              "game.passMap.attacking"
                                            ),
                                            value: "isAttacking",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.attacking"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2732482668
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t(
                                              "game.passMap.defending"
                                            ),
                                            value: "isDefending",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.defending"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            978384492
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t(
                                              "game.passMap.forwards"
                                            ),
                                            value: "isForward",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.forwards"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            2788529516
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t(
                                              "game.passMap.backwards"
                                            ),
                                            value: "isBackward",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.backwards"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            973939100
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t(
                                              "game.passMap.sideways"
                                            ),
                                            value: "isSideways",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.sideways"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1678354819
                                          ),
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            color: "secondary",
                                            label: _vm.$t(
                                              "game.passMap.longBall"
                                            ),
                                            value: "isLongBall",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function () {
                                                  return [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "body-1 primary--text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "game.passMap.longBall"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            false,
                                            1506265293
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("v-divider", { staticClass: "mt-4 mr-2" }),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              {
                                staticClass:
                                  "d-flex justify-end pt-2 pb-0 px-4",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "elevation-0 monospace-font white--text px-3 mx-1",
                                    attrs: {
                                      color: "secondary",
                                      rounded: "",
                                      small: "",
                                      "x-small":
                                        !_vm.$vuetify.breakpoint.xsOnly,
                                      disabled: !_vm.hasChartToExport,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.saveAsPNG()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("file_download")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", {}, [_vm._v("PNG")]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "elevation-0 monospace-font white--text px-3 mx-1",
                                    attrs: {
                                      color: "secondary",
                                      rounded: "",
                                      small: "",
                                      "x-small":
                                        !_vm.$vuetify.breakpoint.xsOnly,
                                      disabled: !_vm.hasChartToExport,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.saveAsSVG()
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("file_download"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("SVG")]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "elevation-0 monospace-font white--text px-3 mx-1",
                                    attrs: {
                                      color: "secondary",
                                      rounded: "",
                                      small: "",
                                      "x-small":
                                        !_vm.$vuetify.breakpoint.xsOnly,
                                      loading: _vm.loadingExport,
                                      disabled:
                                        !_vm.hasExportableElement ||
                                        !_vm.hasChartToExport,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.onGenerateIFrameClick()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("share")]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [_vm._v("Embed")]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex-shrink-0 ml-2 align-self-start" },
                  [_vm._t("filters-toggle")],
                  2
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              ref: "chart",
              class: ["pt-0", _vm.chartColumnAlignClass],
              attrs: {
                cols: "12",
                sm: "12",
                md: _vm.showFilters ? 8 : 10,
                id: "chart",
              },
            },
            [
              _vm.mode === "pass-map"
                ? [
                    _vm.displayModel === "map"
                      ? _c(
                          "div",
                          [
                            _vm.size > 0 && _vm.gameData && _vm.passEventsLoaded
                              ? [
                                  _vm.avatarSize && _vm.mediaMode && _vm.game
                                    ? _c("GameAvatarMedia", {
                                        key: `avatar-${_vm.orientationModel}`,
                                        ref: "gameAvatarMediaRef",
                                        attrs: {
                                          width: _vm.avatarSize.width,
                                          height: _vm.avatarSize.height,
                                          id: `${_vm.gameId}-${_vm.chartId}`,
                                          game: _vm.game,
                                          margin: _vm.margin,
                                          titleLeft: _vm.isMobile
                                            ? _vm.game.homeTeamAlias
                                            : _vm.game.homeTeamName,
                                          titleRight: _vm.isMobile
                                            ? _vm.game.awayTeamAlias
                                            : _vm.game.awayTeamName,
                                          leftColor: _vm.isWhite(
                                            _vm.mediaModeData.leftFillColor
                                          )
                                            ? _vm.mediaModeData.leftBorderColor
                                            : _vm.mediaModeData.leftFillColor,
                                          rightColor: _vm.isWhite(
                                            _vm.mediaModeData.rightFillColor
                                          )
                                            ? _vm.mediaModeData.rightBorderColor
                                            : _vm.mediaModeData.rightFillColor,
                                          bgColor: _vm.mediaModeData.bgColor,
                                          textColor:
                                            _vm.mediaModeData.textColor,
                                          type: "passMap",
                                          lineDistance:
                                            _vm.mediaModeData.lineLength,
                                          avatarSize:
                                            _vm.mediaModeData.avatarSize,
                                          lineWeight:
                                            _vm.mediaModeData.lineWeight,
                                          titleFontSize:
                                            _vm.mediaModeData.titleFontSize,
                                          titleFontWeight:
                                            _vm.mediaModeData.titleFontWeight,
                                          subtitle: _vm.mediaModeData.subtitle,
                                          subtitleFontSize:
                                            _vm.mediaModeData.subtitleFontSize,
                                          subtitleFontWeight:
                                            _vm.mediaModeData
                                              .subtitleFontWeight,
                                          subtitle2:
                                            _vm.mediaModeData.subtitle2,
                                          subtitle2FontSize:
                                            _vm.mediaModeData.subtitle2FontSize,
                                          subtitle2FontWeight:
                                            _vm.mediaModeData
                                              .subtitle2FontWeight,
                                          isVertical:
                                            _vm.orientationModel === "vertical",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("PassMapChartD3", {
                                    key: _vm.passEventsKey,
                                    attrs: {
                                      id: _vm.chartId,
                                      size: _vm.size,
                                      passes: _vm.filteredPassEventsForChart,
                                      passOutcome:
                                        _vm.passOutcome !== "all"
                                          ? _vm.passOutcome === "successful"
                                            ? _vm.$t("eventChart.successful") ||
                                              "Successful"
                                            : _vm.$t(
                                                "eventChart.unsuccessful"
                                              ) || "Unsuccessful"
                                          : "",
                                      passDirection:
                                        _vm.passDirection !== "all"
                                          ? _vm.$t(
                                              `game.passMap.${
                                                _vm.passDirection === "forward"
                                                  ? "forwards"
                                                  : _vm.passDirection ===
                                                    "backward"
                                                  ? "backwards"
                                                  : _vm.passDirection
                                              }`
                                            )
                                          : "",
                                      half: _vm.passMapFilterLine,
                                      showCircles: _vm.showCircles,
                                      showLines: _vm.showLines,
                                      mediaMode: _vm.mediaMode,
                                      legendTitle: _vm.legendTitle,
                                      legendTeamCrest: _vm.legendTeamCrest,
                                      legendTeamName: _vm.legendTeamName,
                                      legendSubtitle: _vm.legendSubtitle,
                                      legendMetrics: _vm.legendMetrics,
                                      orientation: _vm.orientationModel,
                                    },
                                    on: {
                                      sizeChange: function ($event) {
                                        return _vm.onChartSizeChange($event)
                                      },
                                      loaded: function ($event) {
                                        return _vm.onLoaded($event)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.game &&
                                  _vm.avatarSize &&
                                  _vm.size &&
                                  _vm.mediaMode &&
                                  _vm.mediaModeData.socialMedia
                                    ? _c("DriblabSocialMedia", {
                                        ref: "driblabSocialMediaRef",
                                        attrs: {
                                          width: _vm.avatarSize.width,
                                          height: 50,
                                          id: `${_vm.gameId}-${_vm.chartId}`,
                                          margin: _vm.margin,
                                          bgColor: _vm.mediaModeData.bgColor,
                                          textColor:
                                            _vm.mediaModeData.textColor,
                                          fontSize: _vm.isMobile ? "12" : "14",
                                          fontWeight:
                                            _vm.mediaModeData
                                              .socialMediaFontWeight,
                                          logoCfg: _vm.mediaModeData.logo,
                                          sponsor:
                                            _vm.mediaModeData.sponsor.dataUrl,
                                          type: "finishingMap",
                                          isVertical:
                                            _vm.orientationModel === "vertical",
                                          isGame: true,
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showMapsForPDF,
                                          expression: "showMapsForPDF",
                                        },
                                      ],
                                      staticClass:
                                        "report-capture-legacy-pass-maps",
                                      attrs: { "aria-hidden": "true" },
                                    },
                                    [
                                      _vm.size != 0 &&
                                      _vm.filteredPasses.length > 0 &&
                                      _vm.game
                                        ? _c("PassMapChart", {
                                            key: `report-passmap-${_vm.passMapKey}`,
                                            attrs: {
                                              id: `${_vm.gameId}-${_vm.teamId}-${_vm.chartId}`,
                                              size: _vm.size,
                                              margin: _vm.margin,
                                              passes: _vm.filteredPasses,
                                              passesByPlayersName:
                                                _vm.passesByPlayersName,
                                              playersAvgPosition:
                                                _vm.playersAvgPosition,
                                              teamId: _vm.teamId,
                                              teamFormation: _vm.teamFormation,
                                              teamColor: _vm.teamModel
                                                ? _vm.mediaModeData
                                                    .leftFillColor
                                                : _vm.mediaModeData
                                                    .rightFillColor,
                                              strokeColor: _vm.strokeColor,
                                              teamName: _vm.teamModel
                                                ? _vm.mediaModeData.titleLeft
                                                : _vm.mediaModeData.titleRight,
                                              minFrom: _vm.minutes[0],
                                              minTo: _vm.minutes[1],
                                              passesType: _vm.passesType,
                                              language: _vm.currentUserLanguage,
                                              mediaMode: false,
                                              orientation: _vm.orientationModel,
                                            },
                                            on: {
                                              loaded: function ($event) {
                                                return _vm.onLoaded($event)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.size != 0 &&
                                      _vm.filteredPassesMatrix.length > 0 &&
                                      _vm.game
                                        ? _c("PassMatrix", {
                                            key: `report-matrix-${_vm.passMatrixKey}`,
                                            attrs: {
                                              id: `${_vm.gameId}-${_vm.teamId}-${_vm.chartId}`,
                                              size: _vm.size,
                                              margin: _vm.margin,
                                              passes: _vm.filteredPassesMatrix,
                                              homeTeamScore:
                                                _vm.game.homeTeamScore,
                                              rivalTeamScore:
                                                _vm.game.awayTeamScore,
                                              teamName: _vm.homeTeamName,
                                              rivalTeamName: _vm.awayTeamName,
                                              minFrom: _vm.minutes[0],
                                              minTo: _vm.minutes[1],
                                              themeDark: false,
                                              language: _vm.currentUserLanguage,
                                            },
                                            on: {
                                              loaded: function ($event) {
                                                return _vm.onLoaded($event)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              : !_vm.gameData || !_vm.passEventsLoaded
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-center align-center",
                                    staticStyle: { "min-height": "300px" },
                                  },
                                  [
                                    _c("v-progress-circular", {
                                      attrs: {
                                        indeterminate: "",
                                        color: "secondary",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayModel === "table"
                      ? _c(
                          "div",
                          {
                            staticClass: "pass-map-table-export-wrap",
                            attrs: { id: "passMapTableExport" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "rounded text-center pa-2 pt-3",
                                class: _vm.$vuetify.theme.dark
                                  ? "secondary"
                                  : "primary",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "white--text header-font",
                                    staticStyle: { "font-size": "18px" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("table.playerPassMapData.title")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-data-table", {
                              staticClass: "elevation-1 mt-3",
                              attrs: {
                                id: "passMapTable",
                                headers: _vm.passingStatsHeader,
                                items: _vm.passingStatsItems,
                                "items-per-page": _vm.$vuetify.breakpoint.xlOnly
                                  ? _vm.itemsPerPageData
                                  : 10,
                                dense: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  _vm._l(_vm.passingStatsHeader, function (h) {
                                    return {
                                      key: `header.${h.value}`,
                                      fn: function ({ header }) {
                                        return [
                                          _c(
                                            "v-tooltip",
                                            {
                                              key: header.value,
                                              attrs: {
                                                top: "",
                                                color:
                                                  "lightSecondary lighten-4",
                                                "max-width": "300",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({ on }) {
                                                      return [
                                                        _c(
                                                          "span",
                                                          _vm._g({}, on),
                                                          [
                                                            _vm._v(
                                                              _vm._s(h.text)
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "black--text body-1",
                                                },
                                                [_vm._v(_vm._s(h.tooltip))]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    }
                                  }),
                                  {
                                    key: "item.playerName",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            class: _vm.$vuetify.theme.dark
                                              ? "primary--text"
                                              : "secondary--text text--darken-2",
                                            attrs: {
                                              href: "/player/" + item.playerId,
                                            },
                                          },
                                          [_vm._v(_vm._s(item.playerName))]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.pctPasses",
                                    fn: function ({ item }) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDecimal(
                                                item.pctPasses,
                                                0
                                              )
                                            ) + "%"
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.xGChain",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w-100 h-100 d-flex align-center justify-center font-weight-bold",
                                            class: _vm.getTextColorClass(
                                              item,
                                              "xGChain"
                                            ),
                                            style: {
                                              "background-color":
                                                _vm.getBackgroundColor(
                                                  item,
                                                  "xGChain"
                                                ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDecimal(
                                                    item.xGChain,
                                                    2
                                                  )
                                                ) + "%"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.xA",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w-100 h-100 d-flex align-center justify-center font-weight-bold",
                                            class: _vm.getTextColorClass(
                                              item,
                                              "xA"
                                            ),
                                            style: {
                                              "background-color":
                                                _vm.getBackgroundColor(
                                                  item,
                                                  "xA"
                                                ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDecimal(item.xA, 2)
                                                )
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.xT",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "w-100 h-100 d-flex align-center justify-center font-weight-bold",
                                            class: _vm.getTextColorClass(
                                              item,
                                              "xT"
                                            ),
                                            style: {
                                              "background-color":
                                                _vm.getBackgroundColor(
                                                  item,
                                                  "xT"
                                                ),
                                            },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDecimal(item.xT, 2)
                                                ) + "%"
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "connections"
                ? [
                    _vm.displayModel === "matrix"
                      ? _c(
                          "div",
                          {
                            staticClass: "pass-matrix-export-wrap",
                            attrs: { id: "passMatrixExport" },
                          },
                          [
                            _vm.size != 0 &&
                            _vm.filteredPassesMatrix.length > 0 &&
                            _vm.game
                              ? _c("PassMatrix", {
                                  key: _vm.passMatrixKey,
                                  attrs: {
                                    id: `${_vm.gameId}-${_vm.teamId}-${_vm.chartId}`,
                                    size: _vm.size,
                                    margin: _vm.margin,
                                    passes: _vm.filteredPassesMatrix,
                                    homeTeamScore: _vm.game.homeTeamScore,
                                    rivalTeamScore: _vm.game.awayTeamScore,
                                    teamName: _vm.homeTeamName,
                                    rivalTeamName: _vm.awayTeamName,
                                    minFrom: _vm.minutes[0],
                                    minTo: _vm.minutes[1],
                                    themeDark: _vm.$vuetify.theme.dark,
                                    language: _vm.currentUserLanguage,
                                  },
                                  on: {
                                    loaded: function ($event) {
                                      return _vm.onLoaded($event)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayModel === "map"
                      ? _c(
                          "div",
                          [
                            _vm.avatarSize && _vm.mediaMode && _vm.game
                              ? _c("GameAvatarMedia", {
                                  key: `avatar-${_vm.orientationModel}`,
                                  ref: "gameAvatarMediaRef",
                                  attrs: {
                                    width: _vm.avatarSize.width,
                                    height: _vm.avatarSize.height,
                                    id: `${_vm.gameId}-${_vm.chartId}`,
                                    game: _vm.game,
                                    margin: _vm.margin,
                                    titleLeft: _vm.isMobile
                                      ? _vm.game.homeTeamAlias
                                      : _vm.game.homeTeamName,
                                    titleRight: _vm.isMobile
                                      ? _vm.game.awayTeamAlias
                                      : _vm.game.awayTeamName,
                                    leftColor: _vm.isWhite(
                                      _vm.mediaModeData.leftFillColor
                                    )
                                      ? _vm.mediaModeData.leftBorderColor
                                      : _vm.mediaModeData.leftFillColor,
                                    rightColor: _vm.isWhite(
                                      _vm.mediaModeData.rightFillColor
                                    )
                                      ? _vm.mediaModeData.rightBorderColor
                                      : _vm.mediaModeData.rightFillColor,
                                    bgColor: _vm.mediaModeData.bgColor,
                                    textColor: _vm.mediaModeData.textColor,
                                    type: "passMap",
                                    lineDistance: _vm.mediaModeData.lineLength,
                                    avatarSize: _vm.mediaModeData.avatarSize,
                                    lineWeight: _vm.mediaModeData.lineWeight,
                                    titleFontSize:
                                      _vm.mediaModeData.titleFontSize,
                                    titleFontWeight:
                                      _vm.mediaModeData.titleFontWeight,
                                    subtitle: _vm.mediaModeData.subtitle,
                                    subtitleFontSize:
                                      _vm.mediaModeData.subtitleFontSize,
                                    subtitleFontWeight:
                                      _vm.mediaModeData.subtitleFontWeight,
                                    subtitle2: _vm.mediaModeData.subtitle2,
                                    subtitle2FontSize:
                                      _vm.mediaModeData.subtitle2FontSize,
                                    subtitle2FontWeight:
                                      _vm.mediaModeData.subtitle2FontWeight,
                                    isVertical:
                                      _vm.orientationModel === "vertical",
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.size != 0 &&
                            _vm.filteredPasses.length > 0 &&
                            _vm.game
                              ? _c("PassMapChart", {
                                  key: _vm.passMapKey,
                                  attrs: {
                                    id: `${_vm.gameId}-${_vm.teamId}-${_vm.chartId}`,
                                    size: _vm.size,
                                    margin: _vm.margin,
                                    passes: _vm.filteredPasses,
                                    passesByPlayersName:
                                      _vm.passesByPlayersName,
                                    playersAvgPosition: _vm.playersAvgPosition,
                                    teamId: _vm.teamId,
                                    teamFormation: _vm.teamFormation,
                                    teamColor: _vm.teamModel
                                      ? _vm.mediaModeData.leftFillColor
                                      : _vm.mediaModeData.rightFillColor,
                                    strokeColor: _vm.strokeColor,
                                    teamName: _vm.teamModel
                                      ? _vm.mediaModeData.titleLeft
                                      : _vm.mediaModeData.titleRight,
                                    minFrom: _vm.minutes[0],
                                    minTo: _vm.minutes[1],
                                    passesType: _vm.passesType,
                                    language: _vm.currentUserLanguage,
                                    mediaMode: _vm.mediaMode,
                                    orientation: _vm.orientationModel,
                                  },
                                  on: {
                                    sizeChange: function ($event) {
                                      return _vm.onChartSizeChange($event)
                                    },
                                    loaded: function ($event) {
                                      return _vm.onLoaded($event)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.game &&
                            _vm.avatarSize &&
                            _vm.size &&
                            _vm.mediaMode &&
                            _vm.mediaModeData.socialMedia
                              ? _c("DriblabSocialMedia", {
                                  ref: "driblabSocialMediaRef",
                                  attrs: {
                                    width: _vm.avatarSize.width,
                                    height: 50,
                                    id: `${_vm.gameId}-${_vm.chartId}`,
                                    margin: _vm.margin,
                                    bgColor: _vm.mediaModeData.bgColor,
                                    textColor: _vm.mediaModeData.textColor,
                                    fontSize: _vm.isMobile ? "12" : "14",
                                    fontWeight:
                                      _vm.mediaModeData.socialMediaFontWeight,
                                    logoCfg: _vm.mediaModeData.logo,
                                    sponsor: _vm.mediaModeData.sponsor.dataUrl,
                                    type: "finishingMap",
                                    isVertical:
                                      _vm.orientationModel === "vertical",
                                    isGame: true,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.displayModel === "table"
                      ? _c(
                          "div",
                          {
                            staticClass: "pass-map-table-export-wrap",
                            attrs: { id: "passMapConnectionsTableExport" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "rounded text-center pa-2 pt-3",
                                class: _vm.$vuetify.theme.dark
                                  ? "secondary"
                                  : "primary",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "white--text header-font",
                                    staticStyle: { "font-size": "18px" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "game.passMap.passingConnections"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-data-table", {
                              staticClass: "elevation-1 mt-3",
                              attrs: {
                                id: "passMapConnectionsTable",
                                headers: _vm.connectionsHeader,
                                items: _vm.connectionsItems,
                                "items-per-page": _vm.$vuetify.breakpoint.xlOnly
                                  ? _vm.itemsPerPageConnections
                                  : 10,
                                dense: "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "item.playerFrom",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            class: _vm.$vuetify.theme.dark
                                              ? "primary--text"
                                              : "secondary--text text--darken-2",
                                            attrs: {
                                              href:
                                                "/player/" +
                                                _vm.playerNamePlayerIdMap[
                                                  item.playerFrom
                                                ],
                                            },
                                          },
                                          [_vm._v(_vm._s(item.playerFrom))]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.playerTo",
                                    fn: function ({ item }) {
                                      return [
                                        _c(
                                          "a",
                                          {
                                            class: _vm.$vuetify.theme.dark
                                              ? "primary--text"
                                              : "secondary--text text--darken-2",
                                            attrs: {
                                              href:
                                                "/player/" +
                                                _vm.playerNamePlayerIdMap[
                                                  item.playerTo
                                                ],
                                            },
                                          },
                                          [_vm._v(_vm._s(item.playerTo))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2507474724
                              ),
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.game
        ? _c("ChartExportLinksModal", {
            ref: "chartExportLinksModalRef",
            attrs: {
              title: `${_vm.game.homeTeamName} ${_vm.game.homeTeamScore} - ${_vm.game.awayTeamScore} ${_vm.game.awayTeamName}`,
              subtitle: _vm.$t("game.header.gamePassMap"),
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }